module.exports = __webpack_public_path__ + "static/img/colorlogo.c0faba91.png";